export default {
  primary: "#005DF9",
  secondary: "#001E62",
  red: "#e93800",
  white: "#ffffff",
  background: "#f5f5f5",
  greyText: "#999999",
  border: "#d7d7d7",
  black: "#1a1a1a",
  darkGreyText: "#666666",
};
